module.exports = __webpack_public_path__ + "img/logo.12216182.svg";